import React, { useCallback } from 'react';
import {
  ModalOverlay,
  Modal,
  Button,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Image,
} from '@chakra-ui/react';
import {
  useAppDispatch,
  useSetStepMutation,
  setStep,
} from '@spartalabs/pdc-core';
import { OnboardingImage1 } from 'assets';
import { useCustomToast } from 'hooks';
import useAnalyticsEvent from 'hooks/useAnalyticsEvent';
import { GA_ONBOARDING } from 'utils/constants';

interface SideBarProps {
  isOpen: boolean;
}

export default function WelcomeModal({ isOpen }: SideBarProps) {
  const dispatch = useAppDispatch();
  const { handleToast } = useCustomToast();
  const [step, { isLoading }] = useSetStepMutation();

  const analyticsEvent = useAnalyticsEvent({
    category: 'User',
    action: GA_ONBOARDING,
  });

  const handleStep = useCallback(async (destination: number) => {
    try {
      await step(destination).unwrap();

      //Onboarding Analytics
      if (destination === 5) {
        analyticsEvent('Fechado no modal de boas-vindas');
      }

      dispatch(setStep({ step: destination }));
    } catch {
      handleToast({
        step: 4,
        action: 'realizar o onboarding',
      });
    }
  }, []);

  return (
    <Modal isCentered isOpen={isOpen} onClose={() => null}>
      <ModalOverlay />
      <ModalContent maxW={{ base: '90%', md: '548px' }} bg="white" pb="8px">
        <ModalCloseButton
          onClick={() => handleStep(5)}
          color="black"
          size="md"
          bg="white"
          _hover={{ bg: 'grey.200' }}
        />
        <ModalHeader
          p="0px"
          fontSize="md"
          fontWeight={800}
          color="black"
          textAlign="center"
        >
          <Image
            src={OnboardingImage1}
            mb="30px"
            mt="-2px"
            borderTopRadius="4px"
          />
          <Text
            textAlign="center"
            color="text.400"
            fontSize="16px"
            fontWeight="600"
          >
            Boas-vindas ao novo Portal do Cliente da Vamos!
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text
            fontSize="12px"
            textAlign="center"
            color="black"
            fontWeight="400"
            mb="16px"
          >
            Aqui você encontra as informações e serviços que permitem uma gestão
            eficiente das frotas com mais tecnologia e inovação.
          </Text>
          <Text
            fontSize="12px"
            textAlign="center"
            color="black"
            fontWeight="400"
          >
            Conheça as novas funcionalidades de personalização do portal.
          </Text>
        </ModalBody>

        <ModalFooter>
          <Button isLoading={isLoading} onClick={() => handleStep(2)}>
            Iniciar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
